import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; 

import doc1 from "../../assets/Images/comment/1.png";
import doc2 from "../../assets/Images/comment/2.png";
import doc3 from "../../assets/Images/comment/3.png";

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";







const Lo2Doc = () => {
    const navigate = useNavigate();
    const images = [doc1, doc2, doc3];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo2-headings">
                <h1>Code documentation</h1>
                <p>I have to make my code easy to read and maintain</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                        <BreadcrumbHeader />
            </div>

            <div className="content-lo2">
                <div className="content-lo2-doc">
                    <div className="content-lo2-doc-text">
                        <h1>Why is commenting important?</h1>
                        <p>
                            I have learned from the previous semester to work and maintain my code readable for people to check,
                            I do this to makes sure that I know which code does what and to make it easier for me to go back and
                            check for future uses.
                        </p>
                        <h2>Commenting on My Code</h2>
                        <p>
                            It became a habbit from what I learned in the previous semester to add a clear comments on my code,
                            these comments acrs as a quick references, because I understand that I could forget and even lose track 
                            when checking on my own code. By commenting on my code I make sure that:
                            <ul>
                                <li>I can understand my own code</li>
                                <li>Help others understand</li>
                                <li>Will make it easier for me to track what is wrong</li>
                            </ul>
                        </p>
                        <h2>Reusable and Maintainable</h2>
                        <p>
                            With good documentation I can always look back and also use the code for future uses, for some example 
                            with the grid part on my code, I took this from the previous semester 2 that I did.
                        </p>
                        <h2>Practices That Becomes a Habbit</h2>
                        <ul>
                            <li>Adding descriptive comments</li>
                            <li>Spacings</li>
                            <li>Using clear name for variables and function</li>
                        </ul>
                        
                    </div>

                    <div className="content-lo2-doc-slideshow">
                        <Slideshow images={images} />

                    </div>


                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo2Doc;